import { useEffect, useRef, memo } from "react";

// Live market ticker powered by the TradingView ticker-tape widget (dark theme).
function MarketTickerImpl() {
  const container = useRef(null);

  useEffect(() => {
    const el = container.current;
    // Inject once; guard against React StrictMode double-invoke and re-mounts.
    if (!el || el.querySelector("script")) return;
    el.innerHTML = '<div class="tradingview-widget-container__widget"></div>';
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: "FOREXCOM:SPXUSD", title: "S&P 500" },
        { proName: "FOREXCOM:NSXUSD", title: "Nasdaq 100" },
        { proName: "FX_IDC:EURUSD", title: "EUR/USD" },
        { proName: "BITSTAMP:BTCUSD", title: "BTC/USD" },
        { proName: "BITSTAMP:ETHUSD", title: "ETH/USD" },
      ],
      showSymbolLogo: true,
      colorTheme: "dark",
      isTransparent: true,
      largeChartUrl: "https://menagroupfx.com/contact/",
      displayMode: "adaptive",
      locale: "en",
    });
    el.appendChild(script);
  }, []);

  return (
    <div className="relative w-full overflow-hidden border-y border-white/10 bg-navy" data-testid="market-ticker">
      <div className="tradingview-widget-container" ref={container} />
      {/* Mask the TradingView logo pinned at the far edge (blends with the navy bar). */}
      <span className="pointer-events-none absolute inset-y-0 right-0 z-10 w-14 bg-navy" aria-hidden="true" />
    </div>
  );
}

export const MarketTicker = memo(MarketTickerImpl);
